import React from "react";
import { css } from "styled-components/macro";
function createFormInitial(schema, values = {}) {
  return schema.reduce((formOb, current) => {
    formOb[current.name] = values[current.name] ? values[current.name] : "";
    return formOb;
  }, {});
}
function createSendForm(value, schema, type) {
  const cond = type === "multiPart";
  let form = cond ? new FormData() : {};
  Object.keys(value).forEach(current => {
    if (schema) {
      schema.forEach(el => {
        if (el.shouldSend !== false && el.name === current) {
          cond
            ? form.append(current, value[current])
            : (form[current] = value[current] === -1 ? null : value[current]);
        }
      });
    } else {
      cond
        ? form.append(current, value[current])
        : (form[current] = value[current] === -1 ? null : value[current]);
    }
  });
  return form;
}
function SetDefaultValuesForLocations(location, defaultID) {
  let value = {};
  if (defaultID) {
    location.forEach(item => {
      if (defaultID == item.ID) {
        value.defaultValue = {
          label: item.Name,
          value: item.ID
        };
      }
    });
  }
  value.options = location.map(item => ({
    label: item.Name,
    value: item.ID
  }));
  return value;
}
export { createFormInitial, createSendForm, SetDefaultValuesForLocations };
